import { useReceiptStore } from "@elixir/stores";
import { track } from "../../../utils/tracking";
import { getAgeInMonthsFromDob } from "@elixir/utils";
import { docListMassaged } from "../../../organisms/receipt-customisation/customisation-utls";
import {
  TCreateReceiptResponse,
  TGetReceiptPdfConfig,
} from "../../../types/apis";
import { Appointment, AptPatientProfile } from "@elixir/types";

export const FULL_GENDER_CHARS: { [k: string]: string } = {
  M: "Male",
  F: "Female",
  O: "Other",
};

function capitalizeFirstLetter(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

interface PatientDataForReceipt {
  oid: string;
  uhid: string;
  dob?: string;
  gender: string;
  age: number | undefined;
  fn: string;
  ln: string;
  mobile: string;
  extras?: {
    formData?: Array<{
      key: string;
      value: string;
      label: string;
      type: string;
    }>;
  };
}

export function massagePatientProfileForReceipt(
  patient: AptPatientProfile,
  selectedAppointment: Appointment
): PatientDataForReceipt {
  const cleanedAppointment = selectedAppointment || {};
  const cleanedPatient = patient || {};

  let finalUhid = "";
  if (cleanedAppointment?.uhid) {
    finalUhid = cleanedAppointment.uhid;
  } else if (cleanedAppointment?.formData?.length) {
    const uhidData = cleanedAppointment.formData.find(
      (data) => data?.key === "uhid"
    );
    if (uhidData?.value) {
      finalUhid = uhidData.value;
    }
  }

  const ptGender = cleanedPatient?.gen;
  const finalGender = ptGender
    ? FULL_GENDER_CHARS[ptGender?.toUpperCase()] ||
      capitalizeFirstLetter(ptGender)
    : "";

  let finalAge: number | undefined;

  const ptDob = cleanedPatient?.dob;
  if (ptDob) {
    const ageCalculated = getAgeInMonthsFromDob(ptDob);
    if (ageCalculated) finalAge = ageCalculated;
  }

  return {
    ...cleanedPatient,
    uhid: finalUhid,
    gender: finalGender,
    age: finalAge,
    dob: cleanedPatient?.dob || undefined,
  };
}

export const useMassageReceiptDataWithConfigForPDF = () => {
  const setReceiptPayload = useReceiptStore((s) => s.setReceiptPayload);
  const selectedAppointment = useReceiptStore((s) => s.selectedAppointment);
  const setReceiptFileNameV2 = useReceiptStore(
    (state) => state.setReceiptFileNameV2
  );

  const doctor_oid = useReceiptStore((state) => state?.doctor_oid);
  const clinicId = useReceiptStore((state) => state?.clinicId);

  return (response) => {
    const { pdfConfigForGeneration } = response.meta ?? {};
    const { commEventName, ...receiptData } = response.data ?? {};

    const allProfiles = docListMassaged();

    const activeDoctor = allProfiles?.doctors.find(
      (doc) => (selectedAppointment?.doctor_oid || doctor_oid) == doc.oid
    );
    const activeClinic = activeDoctor?.clinics.find(
      (c) => c.id == (selectedAppointment?.clinic_id || clinicId)
    );

    if (response?.generatedFileName) {
      setReceiptFileNameV2(response.generatedFileName);
    }

    setReceiptPayload({
      receiptData: receiptData as TCreateReceiptResponse,
      pdfConfigForGeneration: pdfConfigForGeneration as TGetReceiptPdfConfig,
      patientData: massagePatientProfileForReceipt(
        selectedAppointment?.patient!,
        selectedAppointment!
      ),
      doctorProfile: {
        name: activeDoctor?.name,
        clinicObject: activeClinic,
        headerText: response?.meta?.headerText,
      },
      // commEventName,
    });
  };
};
